/**
 * Created by lari on 08/06/2017.
 */

/* either pass list of files (patients) to display or load files */


(function () {
  'use strict';
  angular.module('vcdms.vcfile')
    .component('consultfilelist', {
      restrict: 'E',
      bindings: {
        consultid: '<?'
      },
      template: `
      <div ng-show="vm.files && vm.files.length > 0">
      <h4>Dateien</h4>
        <table class="table table-striped hidden-xs hidden-sm">
          <thead>
          <tr>
            <th width="15%">Datum</th>
            <th width="30%">Bezeichnung</th>
            <th width="35%">Tags</th>
            <th width="20%">Aktion</th>
          </tr>
          </thead>
          <tr ng-repeat="file in vm.files">
          <td>{{file.created |  moment: \'DD.MM.YYYY hh:mm\'}}</td>
            <td>
                <input type="text" class="form-control" ng-model="file.description" id="desc_{{$index}}" ng-blur="vm.saveFile(file)"></input>
            </td>
            <!-- tags -->
            <td>
            <tags-input ng-model="file.keywords"
                display-property="text"
                id="filekeywords{{$index}}"
                add-on-paste="true"
                add-on-comma="false"
                add-on-enter="true"
                min-length="1"
                ng-blur="vm.saveFile(file)"
                enable-editing-last-tag="true"
                add-from-autocomplete-only="false"
                replace-spaces-with-dashes="false"
                template="filetag-template">
              <auto-complete source="vm.getTags($query)"
                             min-length="1"
                             load-on-focus="true"
                             load-on-empty="false"
                             load-on-down-arrow="true"
                             max-results-to-show="32"
                             select-first-match="true"
                             template="filetagautocomplete-template">
              </auto-complete>
            </tags-input>
<!-- <span class="label label-info tagspacer" ng-repeat="tag in file.flattags">{{tag}}</span> -->
            </td>
            <td>
             <a href="/routes/files/filereader/{{file.fileid}}" target="_blank" class="btn btn-primary btn-xs" uib-tooltip="Datei anzeigen">
                <i class="fa fa-eye"></i>
             </a>
             <a href="/routes/files/filedownload/{{file.fileid}}" class="btn btn-primary btn-xs" uib-tooltip="Datei herunterladen">
                <i class="fa fa-download"></i>
             </a>
             <!-- delete file, mit Rückfrage -->
             <a ng-really-click="vm.removeFile(file, $index)" class="btn btn-danger btn-xs" uib-tooltip="Datei l&ouml;schen"
                ng-really-message="Wollen Sie diese Datei wirklich l&ouml;schen?">
                <i class="fa fa-remove"></i>
             </a>
             <!-- unlink file, mit Rückfrage -->
             <a ng-really-click="vm.unlinkFile(row.entity, $index)" uib-tooltip="Dateizuordnung aufheben"
               ng-really-message="Wollen Sie die Zuordnung dieser Datei r&uuml;ckg&auml;gig machen?"
               class="btn btn-warning btn-xs">
                <i class="fa fa-unlink"></i>
             </a><sprhelp tip="Dateizuordnung aufheben" descref="vm.helpunlink"></sprhelp>
            </td>
          </tr>
        </table>

        <!-- xs, sm view -->
        <div class="hidden-md hidden-lg hidden-xl">
          <div class="row" ng-repeat="file in vm.files">
            <div class="col-xs-6"><input ng-model="file.type" id="type_{{$index}}" ng-blur="vm.saveFile(file)" placeholder="Dateityp ..."></input></span></div>
            <div class="col-xs-6">{{file.created |  moment: \'DD.MM.YYYY hh:mm\'}}</div>
            <!-- Note! <wbr> is needed to allow linebreaking of tag array -->
            <div class="col-xs-12"><span class="label label-info tagspacer" ng-repeat="tag in file.flattags">{{tag}}<wbr></span></div>
            <div class="col-xs-12">             
               <a href="/routes/files/filereader/{{file.fileid}}" target="_blank" class="btn btn-primary btn-xs" uib-tooltip="Datei anzeigen">
                  <i class="fa fa-eye"></i>
               </a>
               <a href="/routes/files/filedownload/{{file.fileid}}" class="btn btn-primary btn-xs" uib-tooltip="Datei herunterladen">
                  <i class="fa fa-download"></i>
               </a>
               <!-- delete file, mit Rückfrage -->
               <a ng-really-click="vm.removeFile(file, $index)" class="btn btn-danger btn-xs" uib-tooltip="Datei l&ouml;schen"
                  ng-really-message="Wollen Sie diese Datei wirklich l&ouml;schen?">
                  <i class="fa fa-remove"></i>
               </a>
               <!-- unlink file, mit Rückfrage -->
               <a ng-really-click="vm.unlinkFile(row.entity, $index)" uib-tooltip="Dateizuordnung aufheben"
                 ng-really-message="Wollen Sie die Zuordnung dieser Datei r&uuml;ckg&auml;gig machen?"
                 class="btn btn-warning btn-xs">
                  <i class="fa fa-unlink"></i>
               </a><sprhelp tip="Dateizuordnung aufheben" descref="vm.helpunlink"></sprhelp>
            </div>
          </div>
        </div>
        </div>
        <!-- tag template -->
<script type="text/ng-template" id="filetag-template">
    <div class="tag-template">
        <div class="right-panel">
            <span>{{$getDisplayText()}}</span>
            <a class="remove-button" ng-click="$removeTag()">&#10006;</a>
        </div>
    </div>
</script>

<!-- tag autocomplete template -->
<script type="text/ng-template" id="filetagautocomplete-template">
    <div class="filetagautocomplete-template" style="z-index: 10000">
        <div>
            <span ng-bind-html="$highlight($getDisplayText())">{{text}}</span>
        </div>
    </div>
</script>
`,
      controllerAs: 'vm',
      controller: ['$log', '$http', 'Rlog', 'File', 'FileHelper', 'vertxEventBusService',
        function ($log, $http, Rlog, File, FileHelper, vertxEventBusService) {
          let vm = this;
          vm.editFile = FileHelper.editFile;
          vm.removeFile = removeFile;
          vm.saveFile = saveFile;
          vm.getTags = getTags;


          vm.$onInit = function () {
            if (angular.isDefined(vm.consultid)) {
              let query = {consultid: vm.consultid, type: 'Datei'};
              File.$search(query).$then(function (files) {
                vm.fileinations = files;
              });
            }
          };

          // vm.consultid might be late propagating, get files on first change
          vm.$onChanges = function (changes) {
            if (!changes.isFirstChange) {
              // if (angular.isDefined(changes.consultid.currentValue)) {
              vm.consultid = changes.consultid.currentValue;
              if (angular.isDefined(vm.consultid)) {
                File.$search({consultid: vm.consultid, type: 'Datei'}).$then(function (files) {
                  vm.files = files;
                }, function (err) {
                  $log.error('file lookup failed for consultid id: ', vm.consultid, err);
                  Rlog.error('file', 'consultfilelist', 'file lookup failed', {consultid: vm.consultid});
                });
              }
            }
          };


          function saveFile(file) {
            if (file.$hasPendingActions()) {
              file.$cancel();
            }
            file.$save().$then(function () {
              vm.saved = true;
            }, function (err) {
              vm.saved = false;
              $log.error('saving of consult failed: ', err);
              Rlog.error('vcutils.consult', 'consulteditor', 'Saving of consult failed: ', {
                consultid: file._id
              });
            });
          }


          function removeFile(file) {
            file.active = false;
            file.$save();
          }

          function getTags(val) {
            $log.debug('debug - getTags called!');
            let myregex = '^' + val; // when using $regex, do not include '/' for regex delimiter
            let match = [
              {$match: {flattags: {$regex: myregex, $options: 'i'}}},
              {$unwind: '$flattags'},
              {$match: {flattags: {$regex: myregex, $options: 'i'}}},
              {$group: {_id: '$flattags', total: {$sum: 1}}}];

            return $http.post('/routes/files/aggregate', match).then(function (response) {
              let tags = [];
              // $log.debug('tags data received: ', response);
              for (let i = 0; i < response.data.length; i++) {
                tags.push({text: response.data[i]._id});
              }
              $log.debug('debug - tags: ', tags);
              return tags;
            });
          }

          const filesUpdateHandler =  function (message) {
            $log.debug('debug: file update received: ', message);
            if (angular.isDefined(vm.files)) {
              vm.files.$refresh().$then(function () {
                $log.debug('debug: filelist refreshed files');
              }, function (error) {
                $log.debug('debug: filelist refresh files failed: ', error);
              });
            }
          };

          vertxEventBusService.on('files.update', {}, filesUpdateHandler);


          vm.$onDestroy = function () {
            $log.debug('[DMS][FILE][ConsultFileList] onDestroy called');
            vertxEventBusService.unregisterHandler('files.update', {}, filesUpdateHandler);
          };

          vm.helpunlink = 'Wenn Sie die Dateizuordnung aufheben, wird die Datei wieder in die Scan- bzw. Dateizuordnungliste eingereiht und kann erneut zugeordnet werden. W&auml;hlen Sie diese Option zum Beispiel dann, wenn Sie eine Datei der falschen Person zugeordnet haben.';

        }] // controller
    }); // component

  // klammerfriedhof
}());
